import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaypalPayLaterComponent } from './paypal-pay-later.component';

@NgModule({
	imports: [CommonModule],
	declarations: [PaypalPayLaterComponent],
	exports: [PaypalPayLaterComponent]
})
export class PaypalPayLaterModule {}
